export const AIRASIA_WHITE_LOGO = 'https://images.contentstack.io/v3/assets/blt51aa173d8d62b412/bltfe00157ad06f779d/60cad7a083f9fe49a6fedbba/white-logo.png';
